import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0;
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import Input from './fieldTypes/Input';
import TextArea from './fieldTypes/Textarea';
import Select from './fieldTypes/Select';
import Users from './fieldTypes/Users';
import PasswordLink from './fieldTypes/PasswordLink';
import ChoiceGroup from './fieldTypes/ChoiceGroup';
import RadioGroup from './fieldTypes/RadioGroup';
import ProfilePhotoUpload from './fieldTypes/ProfilePhotoUpload';
import BBCode from '../richText/BBCode';
import { textStyles, colorPalette } from '../../../styles/styleGuide';
import { fromBreakpoint } from '../../../styles/breakpoints';
import ButtonPrimary from '../buttons/ButtonPrimary';
import validationMessages from './constants/validationMessages';
import excludeValuesFromFormValues from './helpers/excludeValuesFromFormFields';
import flatMap from 'lodash.flatmap';
import isEqual from 'lodash.isequal';
import getSingleValueFromFormValue from './helpers/getSingleValueFromFormValue';
import CheckboxBoolean from './fieldTypes/CheckboxBoolean';
import { PROJECT_UPDATE_NOTIFICATIONS, ARTICLE_NOTIFICATIONS } from '../../../components/dashboard/utils/getProfileFormDefinitionCJ1';
import uuid from 'react-uuid';
var INPUTFIELDTYPEMAP = {
  text: 'input',
  email: 'input',
  password: 'input',
  number: 'input',
  tel: 'input',
  url: 'input',
  bamDate: 'input',
  textarea: 'textarea',
  select: 'select',
  choice: 'choicegroup',
  checkbox: 'choicegroup',
  choicegroup: 'choicegroup',
  radio: 'choicegroup',
  radiogroup: 'radiogroup',
  imageUpload: 'imageUpload',
  readOnly: 'readOnly',
  users: 'users',
  passwordLink: 'passwordLink',
  checkboxBoolean: 'checkboxBoolean'
};
var DefaultValidityState = {
  badInput: false,
  customError: false,
  patternMismatch: false,
  rangeOverflow: false,
  rangeUnderflow: false,
  stepMismatch: false,
  tooLong: false,
  tooShort: false,
  typeMismatch: false
};
var FormGenerator = /*#__PURE__*/function (_Component) {
  function FormGenerator() {
    var _this;
    _classCallCheck(this, FormGenerator);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FormGenerator, [].concat(args));
    _defineProperty(_this, "state", {
      values: {},
      validity: {},
      fieldElements: undefined,
      initialValidationDone: false,
      /** a unique ID for the form, so we can find the form elements inside */
      formId: uuid(),
      initDone: false
    });
    _defineProperty(_this, "initializeValuesAndFields", function (_ref, prevProps) {
      var _ref$fields = _ref.fields,
        fields = _ref$fields === void 0 ? [] : _ref$fields,
        defaultValues = _ref.defaultValues,
        updateStateOnUpdate = _ref.updateStateOnUpdate;
      // For any fields that are not required, we define
      // a validityState object that is valid.
      // For any fields that have been marked as required,
      // we define a validitystate object with keys for
      // value missing.
      var validityForFields = fields.reduce(function (accum, field) {
        return _objectSpread(_objectSpread({}, accum), field.options.reduce(function (acc, cur, i) {
          if (defaultValues && Object.keys(defaultValues).length && typeof defaultValues[cur.name] === 'undefined' && cur.required) {
            acc[cur.name] = Object.assign({}, DefaultValidityState, {
              valid: false,
              valueMissing: true
            });
          } else if (!defaultValues && cur.required) {
            acc[cur.name] = Object.assign({}, DefaultValidityState, {
              valid: false,
              valueMissing: true,
              showValidation: false
            });
          } else {
            acc[cur.name] = Object.assign({}, DefaultValidityState, {
              valid: true,
              valueMissing: false
            });
          }
          return acc;
        }, {}));
      }, {});
      var _this$state = _this.state,
        stateValues = _this$state.values,
        stateValidity = _this$state.validity;
      var prevValues = updateStateOnUpdate && !isEqual(defaultValues, prevProps && prevProps.defaultValues) ? defaultValues : undefined;
      var newState = _objectSpread(_objectSpread({}, _this.state), {}, {
        values: _objectSpread(_objectSpread({}, defaultValues), prevValues || stateValues),
        validity: _objectSpread(_objectSpread({}, validityForFields), stateValidity),
        initDone: true
      });
      if (!isEqual(newState, _this.state)) {
        _this.setState(newState);
      }
    });
    _defineProperty(_this, "handleChange", function (evt) {
      if (!evt) return;
      var target = evt.target;
      var fieldName = target.name;
      var fieldValidity = _this.checkFieldValidity(target);
      var fieldValue;

      // If type is Date Picker, append value
      if (evt.type === 'datePicker') {
        /* $FlowFixMe */
        target.value = evt.detail.value;
      }
      // - If the field type is a checkbox, the value could be either true or false
      // - If field type is a checkbox, but the target id is either 'articleNotifications' or 'projectUpdateNotifications'
      //   we return the checked value as a number
      // - If field type is not a checkbox, we return a single string value
      if (target.type === 'checkbox' && target.id !== ARTICLE_NOTIFICATIONS && target.id !== PROJECT_UPDATE_NOTIFICATIONS) {
        // Inside ChoiceGroup.js we specify data-group-id, so the values are retrievable
        // A choicegroup contains of multiple checkboxes that each have a unique value
        // This value is passed into an array if the checkbox is checked
        if (target.getAttribute('data-group-id')) {
          var choiceGroupCheckboxes = document.querySelectorAll("[data-group-id=\"".concat(target.getAttribute('data-group-id'), "\"]:checked"));
          var choiceGroupValues = Array.from(choiceGroupCheckboxes, function (checkbox) {
            return checkbox.value;
          });
          fieldValue = _defineProperty({}, fieldName, choiceGroupValues);
        } else {
          fieldValue = _defineProperty({}, fieldName, target.checked ? true : false);
        }
      } else if (target.type === 'checkbox' && (target.id === ARTICLE_NOTIFICATIONS || target.id === PROJECT_UPDATE_NOTIFICATIONS)) {
        fieldValue = _defineProperty({}, fieldName, target.checked === false ? 0 : 1);
      } else if (target.type === 'radiogroup') {
        fieldValue = _defineProperty({}, fieldName, target.value);
      } else if (
      // Dropdown
      target.type === 'dropdown' && target.name === 'select') {
        fieldValue = _defineProperty({}, fieldName, target.value);
      } else {
        fieldValue = _defineProperty({}, fieldName, target.value);
      }
      _this.handleFormStateChange(fieldValue, fieldValidity);
    });
    _defineProperty(_this, "handleFormStateChange", function (newValues, newValidity) {
      if (!newValues || !newValidity) return false;
      var onChangeFn = _this.props.onChangeFn;
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          values: _objectSpread(_objectSpread({}, prevState.values), newValues),
          validity: _objectSpread(_objectSpread({}, prevState.validity), newValidity)
        });
      }, function () {
        if (typeof onChangeFn === 'function') {
          onChangeFn(_this.state.values);
        }
      });
      return true;
    });
    _defineProperty(_this, "handleSubmit", function (evt) {
      evt.preventDefault();
      var _this$props = _this.props,
        submitFn = _this$props.submitFn,
        fields = _this$props.fields;
      if (typeof submitFn === 'function' && _this.checkFormValidity()) {
        var submitValues = excludeValuesFromFormValues(fields, _this.state.values);
        submitFn(submitValues);
      }
    });
    _defineProperty(_this, "handleCancel", function (evt) {
      evt.preventDefault();
      var cancelFn = _this.props.cancelFn;
      if (typeof cancelFn !== 'function') return;
      cancelFn();
    });
    _defineProperty(_this, "checkFormValidity", function () {
      var newValidity = _this.state.validity;
      for (var _key4 in newValidity) {
        if (newValidity.hasOwnProperty(_key4)) {
          if (!newValidity[_key4].valid) {
            newValidity[_key4].showValidation = true;
          }
        }
      }
      _this.setState({
        validity: newValidity
      });
      return !Object.keys(_this.state.validity).filter(function (key) {
        return !_this.state.validity[key].valid;
      }).length;
    });
    _defineProperty(_this, "getFieldValidity", function (fieldValidity) {
      if (fieldValidity === undefined) return true;
      return fieldValidity.valid;
    });
    _defineProperty(_this, "getFieldValidationMessage", function (fieldValidity, field) {
      if (!fieldValidity) return;
      var errorMessage = '';
      if (fieldValidity.valid || !fieldValidity || 'showValidation' in fieldValidity && fieldValidity.showValidation === false) return '';
      if (!fieldValidity.valid) {
        errorMessage = field.validationMessage || validationMessages[field.type] || validationMessages[field.id] || validationMessages.required;
      }
      if (field.doubleFor && _this.state.values[field.doubleFor] !== _this.state.values[field.name]) {
        errorMessage = field.validationMessage || "".concat(validationMessages["double"], " ").concat(_this.findField(field.doubleFor));
      }
      return errorMessage;
    });
    _defineProperty(_this, "findField", function (fieldName) {
      var foundFields = flatMap(_this.props.fields, function (formCat) {
        return formCat.options;
      }).filter(function (option) {
        return option.name === fieldName;
      });
      return foundFields.length ? foundFields[0].title : 'het vorige veld';
    });
    _defineProperty(_this, "handleKeyboardEvents", function (evt) {
      // When handling keyboard events, we want to make sure the user has focussed on
      // one of the fields that are part of this form.
      var formFields = _this.props.fields.reduce(function (acc, formCat) {
        return formCat.options.concat(acc);
      }, []);

      // If the form has a textarea, don't submit the form on an enter
      if (formFields.find(function (option) {
        return option.type === 'textarea';
      })) {
        return;
      }
      var fieldNames = formFields.map(function (option) {
        return document.getElementById(option.name);
      });
      if (fieldNames.includes(document.activeElement)) {
        if (evt.key === 'Enter') {
          _this.handleSubmit(evt);
        }
      }
    });
    return _this;
  }
  _inherits(FormGenerator, _Component);
  return _createClass(FormGenerator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeValuesAndFields(this.props);
      window.addEventListener('keydown', this.handleKeyboardEvents, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.getAllFields();
      this.validateAllFields();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.handleKeyboardEvents, false);
    }
  }, {
    key: "getAllFields",
    value: /** get the DOM elements for all form fields inside this form */
    function getAllFields() {
      var _this$state2 = this.state,
        fieldElements = _this$state2.fieldElements,
        initialValidationDone = _this$state2.initialValidationDone,
        formId = _this$state2.formId,
        initDone = _this$state2.initDone;
      if (!!fieldElements || initialValidationDone || !initDone) {
        return;
      }
      var newFieldElements = document.getElementById(formId).querySelectorAll('input, textarea, select');
      this.setState({
        fieldElements: newFieldElements
      });
    }

    /** update the form field validity in the state for all form fields inside this form; this is for the initial validity state */
  }, {
    key: "validateAllFields",
    value: function validateAllFields() {
      var _this2 = this;
      var _this$state3 = this.state,
        fieldElements = _this$state3.fieldElements,
        initialValidationDone = _this$state3.initialValidationDone,
        initDone = _this$state3.initDone;
      if (!fieldElements || initialValidationDone || !initDone) {
        return;
      }
      var validity = {};
      fieldElements.forEach(function (el) {
        validity[el.name] = _this2.checkFieldValidity(el)[el.name];
      });
      this.setState({
        validity: validity,
        initialValidationDone: true
      });
    }

    /** determine whether all fields are valid, to enable/disable the submit button */
  }, {
    key: "allFieldsAreValid",
    value: function allFieldsAreValid() {
      var validity = this.state.validity;
      return !Object.values(validity).some(function (field) {
        return !field.valid;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        _this$props2$fields = _this$props2.fields,
        fields = _this$props2$fields === void 0 ? [] : _this$props2$fields,
        color = _this$props2.color,
        togglePassword = _this$props2.togglePassword,
        formNote = _this$props2.formNote,
        submitButtonPosition = _this$props2.submitButtonPosition,
        showCancel = _this$props2.showCancel,
        cancelLabel = _this$props2.cancelLabel,
        cancelButtonColorHover = _this$props2.cancelButtonColorHover,
        cancelLabelColorHover = _this$props2.cancelLabelColorHover,
        cancelLabelColor = _this$props2.cancelLabelColor,
        cancelButtonColor = _this$props2.cancelButtonColor,
        submitLabel = _this$props2.submitLabel,
        loadingLabel = _this$props2.loadingLabel,
        loading = _this$props2.loading,
        submitButtonColor = _this$props2.submitButtonColor,
        submitButtonColorHover = _this$props2.submitButtonColorHover,
        submitLabelColor = _this$props2.submitLabelColor,
        submitLabelColorHover = _this$props2.submitLabelColorHover;
      var formId = this.state.formId;
      return __jsx(Form, {
        noValidate: true,
        method: "post",
        "data-id": "forms_FormGenerator_Form"
      }, fields.map(function (field, index) {
        return __jsx(FormContainer, {
          id: formId,
          key: index,
          "data-id": "forms_FormGenerator_FormContainer"
        }, field.categoryTitle && __jsx(CategoryTitle, {
          "data-id": "forms_FormGenerator_CategoryTitle"
        }, field.categoryTitle), field.categoryDescription && __jsx(Description, {
          "data-id": "forms_FormGenerator_Description"
        }, field.categoryDescription), field.options.map(function (field, index) {
          var FormEl;
          var fieldProps = {
            id: field.name,
            name: field.name,
            type: field.type,
            title: field.title,
            label: field.type === 'checkbox' || field.type === 'checkboxBoolean' || field.type === 'radio' || field.type === 'select' || field.type === 'choice' || field.type === 'passwordLink' ? field.label : field.title,
            color: color,
            defaultChecked: _this3.state.values[field.name] || field.defaultChecked,
            defaultValue: getSingleValueFromFormValue(_this3.state.values[field.name]),
            className: !!_this3.state.values[field.name] ? 'filled' : '',
            required: field.required,
            validationMessage: _this3.getFieldValidationMessage(_this3.state.validity[field.name], field),
            onChange: field.type !== 'imageUpload' ? _this3.handleChange : undefined,
            isValid: _this3.getFieldValidity(_this3.state.validity[field.name] || undefined),
            maxLength: field.type === 'bamDate' ? 10 : field.maxLength || undefined,
            toggle: field.toggle,
            togglePassword: togglePassword,
            pattern: field.doubleFor ? getSingleValueFromFormValue(_this3.state.values[field.doubleFor]) : field.pattern,
            checked: field.type === 'checkboxBoolean' ? _this3.state.values[field.name] : false,
            hasIcons: field.has_icons || false
          };
          switch (INPUTFIELDTYPEMAP[field.type]) {
            case 'input':
              FormEl = __jsx(Input, _extends({}, fieldProps, {
                "data-id": "forms_FormGenerator_Input"
              }));
              break;
            case 'textarea':
              FormEl = __jsx(TextArea, _extends({}, fieldProps, {
                "data-id": "forms_FormGenerator_TextArea"
              }));
              break;
            case 'select':
              FormEl = __jsx(Select, _extends({}, fieldProps, {
                choices: field.choices,
                "data-id": "forms_FormGenerator_Select"
              }));
              break;
            case 'choicegroup':
              FormEl = __jsx(ChoiceGroup, _extends({}, fieldProps, {
                choices: field.choices,
                choiceGroupId: field.id,
                "data-id": "forms_FormGenerator_ChoiceGroup"
              }));
              break;
            case 'radiogroup':
              FormEl = __jsx(RadioGroup, _extends({}, fieldProps, {
                choices: field.choices,
                "data-id": "forms_FormGenerator_RadioGroup"
              }));
              break;
            case 'checkboxBoolean':
              FormEl = __jsx(CheckboxBoolean, _extends({}, fieldProps, {
                "data-id": "forms_FormGenerator_CheckboxBoolean"
              }));
              break;
            case 'imageUpload':
              FormEl = __jsx(ProfilePhotoUpload, _extends({}, fieldProps, {
                uploadType: field.uploadType,
                "data-id": "forms_FormGenerator_ProfilePhotoUpload"
              }));
              break;
            case 'readOnly':
              FormEl =
              // $FlowFixMe
              __jsx(BBCode, {
                content: {
                  content: field.label || '',
                  pages: field.pages ? field.pages : {}
                },
                "data-id": "forms_FormGenerator_BBCode"
              });
              break;
            case 'users':
              FormEl = __jsx(Users, _extends({}, fieldProps, {
                link: field.link,
                "data-id": "forms_FormGenerator_Users"
              }));
              break;
            case 'passwordLink':
              FormEl = __jsx(PasswordLink, _extends({}, fieldProps, {
                "data-id": "forms_FormGenerator_PasswordLink"
              }));
              break;
            default:
              FormEl = 'Dit formulier element wordt nog niet ondersteund.';
              break;
          }
          return __jsx(FormField, {
            className: 'formfield_' + field.id,
            key: field.id,
            "data-id": "forms_FormGenerator_FormField"
          }, FormEl, field.help && __jsx(FormHelp, {
            "data-id": "forms_FormGenerator_FormHelp"
          }, field.help));
        }));
      }), formNote && __jsx(FormNote, {
        "data-id": "forms_FormGenerator_FormNote"
      }, __jsx(BBCode, {
        content: formNote,
        "data-id": "forms_FormGenerator_BBCode"
      })), __jsx(FormButtons, {
        submitButtonPosition: submitButtonPosition,
        "data-id": "forms_FormGenerator_FormButtons"
      }, showCancel && __jsx(ButtonPrimary, {
        id: "form_cancel",
        type: "button",
        label: cancelLabel || '',
        clickHandler: this.handleCancel,
        buttonColor: cancelButtonColor,
        buttonHoverColor: cancelButtonColorHover,
        labelColor: cancelLabelColor,
        labelHoverColor: cancelLabelColorHover,
        "data-id": "forms_FormGenerator_ButtonPrimary"
      }), __jsx(ButtonPrimary, {
        id: "form_submit",
        type: "button",
        label: submitLabel,
        loadingLabel: loadingLabel || submitLabel,
        loading: loading,
        buttonColor: submitButtonColor,
        buttonHoverColor: submitButtonColorHover,
        labelColor: submitLabelColor,
        labelHoverColor: submitLabelColorHover,
        clickHandler: this.handleSubmit,
        disabled: !this.allFieldsAreValid(),
        "data-id": "forms_FormGenerator_ButtonPrimary_20"
      })));
    }
  }, {
    key: "checkFieldValidity",
    value: function checkFieldValidity(formField) {
      // This gets the HTML5 input validity
      // If the checkbox is required set validation based on if it's checked or not
      if (formField.type === 'checkbox') {
        if (formField.getAttribute('data-group-id')) {
          var groupId = formField.getAttribute('data-group-id');
          var checkboxes = document.querySelectorAll("[data-group-id=\"".concat(groupId, "\"]"));
          var checkedCount = Array.from(checkboxes).filter(function (cb) {
            return cb.checked;
          }).length;
          return _defineProperty({}, formField.name, {
            valid: checkedCount > 0 || !formField.required,
            showValidation: checkedCount === 0 && formField.required
          });
        }
        return _defineProperty({}, formField.name, formField.checked || !formField.required ? {
          valid: formField.validity.valid
        } : {
          valid: false
        });
      }
      if (formField.type === 'radio') {
        return _defineProperty({}, formField.name, {
          valid: formField.checked || !formField.required,
          // either it is initial state, no interaction yet, so no feedback
          // or user has selected one and cannot undo that, so feedback is not required
          showValidation: false
        });
      }
      if (formField.type === 'select-one') {
        return _defineProperty({}, formField.name, {
          valid: formField.validity.valid,
          // either it is initial state, no interaction yet, so no feedback
          // or user has selected one and cannot undo that, so feedback is not required
          showValidation: false
        });
      }
      return _defineProperty({}, formField.name, formField.validity);
    }
  }]);
}(Component);
export default FormGenerator;
var Form = styled.form(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n\n  > button {\n    margin-top: 40rem;\n  }\n"])));
var FormContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 40rem;\n"])));
var CategoryTitle = styled.h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-top: 50rem;\n  margin-bottom: 10rem;\n"])), textStyles.title, colorPalette.headerGrey);
var Description = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", " font-weight: normal;\n  color: ", ";\n  margin-top: 14rem;\n"])), textStyles.subTitle, colorPalette.textGrey);
var FormField = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  padding-top: 15rem;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding-top: 30rem;\n  "]))));
var FormNote = styled.h6(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n"])), textStyles.caption);
var FormButtons = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column-reverse;\n  margin-top: 30rem;\n\n  > button {\n    margin-bottom: 15rem;\n  }\n\n  ", ";\n"])), fromBreakpoint.lg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (props) {
  return props.submitButtonPosition === 'left' ? "\n      flex-direction: row-reverse;\n      justify-content: flex-end;\n    " : "\n      flex-direction: row;\n    ";
}));
var FormHelp = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  ", ";\n  padding-top: 3rem;\n  color: ", ";\n"])), textStyles.caption, colorPalette.textGrey);